import { Link, useLocation } from 'react-router-dom';
import { SITE } from '../../config/site';
import { SEO_PAGES } from '../../config/seo';
import { CATEGORY_TILES } from '../../config/categories';
import { Seo } from '../../components/seo';
import styles from './NotFoundPage.module.css';

const QUICK_LINKS = [
  { to: '/catalog', label: 'Каталог' },
  { to: '/retail-store', label: 'Розничный магазин' },
  { to: '/delivery', label: 'Доставка' },
  { to: '/food-printing', label: 'Пищевая печать' },
];

const POPULAR_CATEGORIES = CATEGORY_TILES.slice(0, 6);

export function NotFoundPage() {
  const location = useLocation();
  const seo = SEO_PAGES.notFound;

  return (
    <div className={`container ${styles.page}`}>
      <Seo
        title={seo.title}
        description={seo.description}
        path={location.pathname || '/'}
        noindex
      />

      <p className={styles.code} aria-hidden="true">
        404
      </p>
      <h1 className={styles.title}>Страница не найдена</h1>
      <p className={styles.text}>
        Возможно, ссылка устарела после обновления сайта. Найдите нужный товар в каталоге — в
        магазине {SITE.name} более 3400 позиций для кондитеров.
      </p>

      <div className={styles.actions}>
        <Link to="/catalog" className={styles.primaryBtn}>
          Перейти в каталог
        </Link>
        <Link to="/" className={styles.secondaryBtn}>
          На главную
        </Link>
      </div>

      <nav className={styles.nav} aria-label="Полезные разделы">
        <h2 className={styles.navTitle}>Популярные разделы</h2>
        <ul className={styles.navList}>
          {QUICK_LINKS.map((link) => (
            <li key={link.to}>
              <Link to={link.to}>{link.label}</Link>
            </li>
          ))}
        </ul>
      </nav>

      <nav className={styles.nav} aria-label="Популярные категории">
        <h2 className={styles.navTitle}>Популярные категории</h2>
        <ul className={styles.categoryList}>
          {POPULAR_CATEGORIES.map((category) => (
            <li key={category.id}>
              <Link to={`/catalog?category=${category.categoryId}`}>{category.name}</Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
